import { parseHtmlString } from "@/utils/helpers/html";
import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";


const AboutAFSA = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-4">
          <Heading level={4} >{data.title ?? "Default Title"}</Heading>
        </div>
        <Paragraph dangerouslySetInnerHTML={parseHtmlString(data.description ?? "Default Description")} />
      </div>
    </EditableSection>
  )
}

export default AboutAFSA